export enum VideoQuestion {
  MAIN = 'MAIN',
  SUB1 = 'SUB1',
  SUB2 = 'SUB2',
  SUB3 = 'SUB3 ',
}

export const videoQuestionTypeStringMap: Record<VideoQuestionType, string> = {
  MAIN: '',
  SUB1: '1',
  SUB2: '2',
  SUB3: '3',
};

export type VideoQuestionType = keyof typeof VideoQuestion;
